__turbopack_context__.v({
  "controls": "eRVBGq_controls",
  "dots": "eRVBGq_dots",
  "slide": "eRVBGq_slide",
  "viewport": "eRVBGq_viewport",
  "wrapper": "eRVBGq_wrapper",
});
